export interface MessageList {
	role: MessageRoleEnum;
	type?: string;
	content?: string;
	options?: string[];
}

export enum MessageRoleEnum {
	User = 'user',
	Assistant = 'assistant'
}

export enum ChatResponseTypeEnum {
	Status = 'status',
	FinalState = 'final_state',
	WaitingForInput = 'waiting_for_input'
}
